import { useState, useEffect, useContext } from 'react'
import Router from 'next/router'

// Context
import { ModalContext } from '../../context/ModalContext'
import { NavigationContext } from '../../context/NavigationContext'
import { AppContext } from '../../context/AppContext'
import ModalGalleryProvider from '../../context/ModalGalleryContext'

// Internal components
import Svg from '../Svg/Svg'
import ModalContent from '../ModalContent/ModalContent'
import ModalGallery from '../ModalGallery/ModalGallery'

const Modal = () => {
  // Contexts
  const modalContext = useContext(ModalContext)
  const appContext = useContext(AppContext)
  const navigationContext = useContext(NavigationContext)

  // States
  const [modalType, setModalType] = useState(false)

  useEffect(() => {
    if (modalContext.modalIsActive && !modalType) setModalType(modalContext.modalType)

    if (!modalContext.modalIsActive) {
      if (modalContext.stateClass) modalContext.setStateClass(false)
      if (modalContext.modalRoute) modalContext.setModalRoute(false)
      if (modalContext.modalId) modalContext.setModalId(false)
      if (modalContext.modalPlaylist) modalContext.setModalPlaylist(false)
      if (modalContext.modalMandatory) modalContext.setModalMandatory(false)
      if (modalContext.modalType) modalContext.setModalType(false)
      if (modalContext.modalResponse) modalContext.setModalResponse(false)
      if (modalContext.modalModifier) modalContext.setModalModifier('')
      if (modalType) setModalType(false)
    }
  }, [modalContext.modalIsActive])

  useEffect(() => {
    if (navigationContext.routeChange === true) {
      setModalType(false)
      modalContext.setModalIsActive(false)
    }
  }, [navigationContext.routeChange])

  useEffect(() => {
    if (modalContext.modalPromptTrigger) closeModalOnClick()
    modalContext.setModalPromptTrigger(false)
  }, [modalContext.modalPromptTrigger])

  const closeModalOnClick = () => {
    // Check if there should be a prompt
    if (!modalContext.modalCanPrompt) {
      modalContext.setModalIsActive(false)
    } else {
      // Check if dirty or native, redirect to the new page
      handleModalPrompt()
    }
  }

  const handleModalPrompt = () => {
    // When the drawing tool is open, open drawing tool prompt instead
    if (modalContext.modalFrameActive) {
      modalContext.setModalHasFramePrompt(true)
      return
    }

    // When the modal has NO new data, disable the prompt & modal
    if (!modalContext.modalIsNextPage) {
      modalContext.setModalHasPrompt(false)
      modalContext.setModalPrompt(false)
      modalContext.setModalIsActive(false)
    } else {
      // When the modal has new data, enable the prompt
      modalContext.setModalHasPrompt(true)
      modalContext.setModalPrompt(true)
    }

    // Check to send to a blank page or push the page directly
    if (modalContext.modalPromptRedirect && !modalContext.modalIsNextPage) {
      // If native app open window in current screen and close the prompt
      if (appContext.isNativeApp) {
        if (!modalContext.modalIsDirty) {
          Router.push(modalContext.modalPromptRedirect)
          modalContext.setModalPromptRedirect(false)
          return
        }
        modalContext.setModalHasPrompt(true)
        modalContext.setModalPrompt(true)
      } else {
        // If web open window in a new tab and close the prompt
        const newWindow = window.open(modalContext.modalPromptRedirect, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
        modalContext.setModalPromptRedirect(false)
        modalContext.setModalHasPrompt(false)
        modalContext.setModalPrompt(false)
        modalContext.setModalIsActive(true)
      }
    }
  }

  const RenderModalClose = () => {
    return (
      <div className="Modal-close" onClick={() => closeModalOnClick()}>
        <Svg id={'icon-close'} modifiers={['Modal-closeIcon']} />
      </div>
    )
  }

  return (
    modalContext.modalIsActive && (
      <>
        <div
          className={`Modal ${modalType ? `Modal-${modalType}` : ''} ${modalContext.stateClass || ''} ${
            modalContext?.modalModifier
          } ${modalContext?.modalFrameActive ? 'has-iframe' : ''}`}
          tabIndex="-1"
        >
          <div className="Modal-container">
            <div className="Modal-wrapper">
              <div className="Modal-body">
                {modalType && modalType === 'api' && <ModalContent />}
                {modalType && modalType === 'gallery' && (
                  <ModalGalleryProvider>
                    <ModalGallery />
                  </ModalGalleryProvider>
                )}
                {!modalContext.modalMandatory && <RenderModalClose />}
              </div>
            </div>
          </div>
        </div>
        <div
          className="Modal-overlay"
          onClick={() => {
            if (!modalContext.modalMandatory) closeModalOnClick()
          }}
        ></div>
      </>
    )
  )
}

export default Modal
